/* CW zone finder: look up the USDA hardiness zone for a US ZIP (phzmapi.org) and go to
   the matching /collections/hardy-in-zone-N. Zones 10 and up go to the warm link. */
(function () {
  if (window.cwZoneFinder) return;
  window.cwZoneFinder = true;

  function zoneUrl(form, zone) {
    var min = parseInt(form.dataset.cwMin, 10) || 4;
    var max = parseInt(form.dataset.cwMax, 10) || 11;
    if (zone > 9) return form.dataset.cwWarm || '/collections/all';
    if (zone < min) zone = min;
    if (zone > max) zone = max;
    return (form.dataset.cwPattern || '/collections/hardy-in-zone-[zone]').replace('[zone]', String(zone));
  }

  function say(form, text) {
    var s = form.querySelector('[data-cw-zip-status]');
    if (!s) return;
    s.textContent = text;
    s.hidden = !text;
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-cw-zone-form')) return;
    evt.preventDefault();
    var input = form.querySelector('input[name="zip"]');
    var zip = (input.value || '').trim().slice(0, 5);
    if (!/^\d{5}$/.test(zip)) {
      say(form, 'Enter a 5 digit US ZIP code.');
      input.focus();
      return;
    }
    if (!window.fetch) {
      say(form, 'Pick your zone below.');
      return;
    }
    say(form, 'Looking up ' + zip + '...');
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('https://phzmapi.org/' + zip + '.json')
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (data) {
        var zone = parseInt(String(data.zone || '').replace(/[^0-9]/g, ''), 10);
        if (!zone) throw new Error('no zone');
        say(form, 'Zone ' + data.zone + '. Showing plants that can handle your winter.');
        window.location.href = zoneUrl(form, zone);
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        say(form, 'We could not find that ZIP. Pick your zone below instead.');
      });
  });
})();
